export interface Transfer {
  athleteUrl: string;
  classYear?: number;
  collegePlayerId: number;
  collegePlayerName: string;
  collegePlayerPosition?: string;
  collegePlayerProfileImage?: string;
  entryDate: string | Date;
  eventType: TRANSFER_PORTAL_EVENTS;
  exitCollegeColor?: string;
  exitCollegeLogo?: string;
  exitCollegeName?: string;
  exitDate?: string | Date;
  intentDate?: string | Date;
  originCollegeColor?: string;
  originCollegeLogo?: string;
  originCollegeName: string;
  personId: number;
}

export enum TRANSFER_PORTAL_EVENTS {
  PORTAL_ENTRY = "PORTAL_ENTRY",
  PORTAL_EXIT = "PORTAL_WITHDRAW",
  PORTAL_INTENT = "PORTAL_INTENT",
  PORTAL_TRANSFER = "PORTAL_TRANSFER"
}

export enum ENTRY_TYPE_LABELS {
  ENTERED = "Entered",
  INTENT = "Intends to Enter"
}

export enum ENTRY_TYPES {
  ENTERED = "ENTERED",
  INTENT = "INTENT"
}

export enum EXIT_TYPES {
  NOT_SIGNED = "NOT_SIGNED",
  TRANSFERRED = "TRANSFERRED",
  WITHDREW = "WITHDREW"
}

export enum STATUSES {
  ENTERED = "In Transfer Portal",
  INTENT = "Intends to Enter Transfer Portal",
  NOT_SIGNED = "Never Signed",
  TRANSFERRED = "Transferred",
  WITHDREW = "Withdrew"
}
